var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    className: "icon",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M755.5 959.5h-485c-9.9 0-18.1-7.7-18.6-17.6L214.6 289c-.6-10.3 7.3-19.1 17.6-19.7 10.5-.4 19.1 7.3 19.7 17.6l36.3 635.3h449.7l36.3-635.3c.6-10.3 9.6-17.9 19.7-17.6 10.3.6 18.1 9.4 17.6 19.7l-37.3 652.8c-.7 9.9-8.8 17.7-18.7 17.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M867.4 288H158.6c-10.3 0-18.7-8.3-18.7-18.7v-74.6c0-9.1 6.6-16.9 15.6-18.4L367.2 141l15.3-62.7c2-8.4 9.5-14.2 18.1-14.2h224.2c8.6 0 16 5.8 18.1 14.1l15.7 62.7 211.8 35.3c9 1.5 15.6 9.3 15.6 18.4v74.6c.1 10.4-8.3 18.8-18.6 18.8zm-690.2-37.3h671.5v-40.2l-208.3-34.7c-7.3-1.2-13.2-6.7-15-13.9l-15.1-60.5h-195l-14.8 60.4c-1.8 7.2-7.7 12.8-15 14l-208.3 34.7v40.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E8F79",
    d: "M548.8 700.7c-110.6 0-213-34.6-297.3-93.5l19.1 333.6h485l16.6-290.4c-67.8 32.2-143.5 50.3-223.4 50.3z",
    className: "selected",
    "data-spm-anchor-id": "a313x.7781069.0.i3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M755.5 959.5h-485c-9.9 0-18.1-7.7-18.6-17.6l-19.1-333.6c-.4-7.1 3.3-13.9 9.5-17.3 6.2-3.5 13.9-3.1 19.8 1 84.4 59 183.5 90.1 286.6 90.1 75.3 0 147.7-16.3 215.3-48.5 5.9-2.9 13-2.3 18.4 1.3 5.5 3.7 8.6 10 8.2 16.5L774 941.8c-.5 9.9-8.6 17.7-18.5 17.7zm-467.4-37.3h449.7l13.8-242.4c-64.4 26.3-132.5 39.6-203 39.6-98.2 0-193.1-26.3-276.6-76.5l16.1 279.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M625.7 847.5h-.8c-10.3-.4-18.3-9.1-17.9-19.4l18.7-447.7c.4-10.3 8.6-18.6 19.4-17.9 10.3.4 18.3 9.1 17.9 19.4l-18.7 447.7c-.4 10.1-8.6 17.9-18.6 17.9zm-223.8 0c-9.9 0-18.2-7.9-18.6-17.9L364.6 382c-.4-10.3 7.6-19 17.9-19.4 10.4-.8 19 7.6 19.4 17.9l18.7 447.7c.4 10.3-7.6 19-17.9 19.4-.3-.1-.6-.1-.8-.1zm111.9 0c-10.3 0-18.7-8.3-18.7-18.7V381.2c0-10.3 8.4-18.7 18.7-18.7 10.3 0 18.7 8.3 18.7 18.7v447.7c0 10.3-8.4 18.6-18.7 18.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.acb7c0f10cd5ad3bc6da1d27954700ca.svg";
export { ForwardRef as ReactComponent };